import React from "react";
import { colorClass } from "../taskConstants";

function LabelChip({ label }) {
  if (!label) return null;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-Medium ${colorClass(label.color)}`}>
      {label.name}
    </span>
  );
}

export default LabelChip;
